// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"d36b4ffb","186":"d36b4ffb"}[chunkId] + ".chunk.css";
};